import { render, staticRenderFns } from "./AttentionBox.vue?vue&type=template&id=529ab57f"
import script from "./AttentionBox.vue?vue&type=script&lang=js"
export * from "./AttentionBox.vue?vue&type=script&lang=js"
import style0 from "./AttentionBox.vue?vue&type=style&index=0&id=529ab57f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports